import { BellIcon, XIcon } from '@heroicons/react/outline'

function ErrorNotice({ children, onRemove }) {
    return (
        <div className="rounded-lg shadow-lg bg-red-400 text-white z-50 fixed top-2 left-2 right-2 p-4">
            <div className="flex items-center">
                <div className="flex-shrink-0">
                    <BellIcon className="h-5 w-5" />
                </div>
                <div className="ml-4">
                    <p className="text-sm font-semibold">{children}</p>
                </div>
                <div className="ml-auto pl-2">
                    <div className="-mx-2 -my-2">
                        <button
                            onClick={onRemove}
                            type="button"
                            className="bg-transparent text-white font-semibold flex items-center border border-transparent rounded-lg p-2 text-center cursor-pointer hover:bg-olh hover:border-olh hover:text-white focus:outline-none focus:ring-1 focus:ring-olh focus:border-olh sm:text-sm">
                            <XIcon className="h-5 w-5" aria-hidden="true" />
                        </button>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ErrorNotice
